import { Lock01 } from '@/components/common/icons';
import PartnerAvatar from '@/components/common/PartnerAvatar';
import UserAvatar from '@/components/common/UserAvatar';
import { AvatarProps, Box, BoxProps, Circle } from '@chakra-ui/react';

export const SingleAvatar = ({
    withLock,
    isPartner,
    size = 'xs',
    bg = 'white',
    ...props
}: BoxProps & {
    withLock?: boolean;
    isPartner?: boolean;
    size?: AvatarProps['size'];
    bg?: AvatarProps['bg'];
}) => {
    const Avatar = isPartner ? PartnerAvatar : UserAvatar;
    const avatarStyles = {
        border: '2px solid',
        borderTopColor: bg,
        borderBottomColor: bg,
        borderRightColor: bg,
        borderLeftColor: bg,
        size: size,
    };

    return (
        <Box pos="relative" {...props}>
            <Avatar {...avatarStyles} />
            {withLock && (
                <Circle
                    size={6}
                    border="2px solid"
                    borderColor="gray.700"
                    top={-1.5}
                    left={-2.5}
                    pos="absolute"
                    bg="black"
                    rounded="full"
                >
                    <Lock01 size="xs" color="white" />
                </Circle>
            )}
        </Box>
    );
};

export const OverlappingAvatars = ({
    size = 'xs',
    bg = 'white',
    userAvatarLeft = -7,
    ...props
}: BoxProps & {
    size?: AvatarProps['size'];
    bg?: AvatarProps['bg'];
    userAvatarLeft?: number;
}) => {
    const avatarStyles = {
        size: size,
        border: '2px solid',
        borderTopColor: bg,
        borderBottomColor: bg,
        borderRightColor: bg,
        borderLeftColor: bg,
    };

    const userAvatarStyles = {
        ...avatarStyles,
        left: userAvatarLeft,
    };

    return (
        <Box pos="relative" {...props}>
            <UserAvatar {...userAvatarStyles} zIndex={10} pos="absolute" />
            <PartnerAvatar {...avatarStyles} />
        </Box>
    );
};
